export default __webpack_public_path__ + "static/Museo-Sans-300-98d590bff6950a6b6a438e18f89655be.woff2";